import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import { LiveInput, InputRow } from './inputsDemoHelpers';

function InputsToggleDemoComponent() {
  return (
    <div>
      <InputRow label='Bool — segmented Yes / No toggle (bit)'>
        <LiveInput
          type={InputTypesEnum.Bool}
          fieldName='demoBool'
          labelText='Is active'
        />
      </InputRow>
      <InputRow label='Checkbox — single boolean box'>
        <LiveInput
          type={InputTypesEnum.Checkbox}
          fieldName='demoCheckbox'
          labelText='Include in report'
        />
      </InputRow>
      <InputRow label='OnOff — toggle switch'>
        <LiveInput
          type={InputTypesEnum.OnOff}
          fieldName='demoOnOff'
          labelText='Notifications'
        />
      </InputRow>
      <InputRow label='SingleCheckBox — inline toggle, no label/eraser chrome'>
        <LiveInput
          type={InputTypesEnum.SingleCheckBox}
          fieldName='demoSingleCheck'
          labelText='Accepted'
        />
      </InputRow>
      <InputRow label='EmptyYesNoSelect — blank / Yes / No dropdown'>
        <LiveInput
          type={InputTypesEnum.EmptyYesNoSelect}
          fieldName='demoEmptyYesNo'
          labelText='Confirmed'
        />
      </InputRow>
    </div>
  );
}

export const inputsToggleDemo = {
  id: 'inputs-toggles',
  title: 'Toggles & booleans',
  category: 'Inputs',
  importPath: 'src/Elements/InputComponents/InputWithClear.js (type=Bool / Checkbox / OnOff / …)',
  notes: [
    'All map to a bit column. Bool is a segmented Yes/No toggle (.ds-seg, the "Segmented toggle" component); EmptyYesNoSelect is a blank/Yes/No dropdown; Checkbox, OnOff and SingleCheckBox are inline controls.',
    'SingleCheckBox is in TYPES_WITHOUT_LABEL and TYPES_WITHOUT_ERASER (inputTypeGroups.js) — it renders inline with no field label or eraser button.',
    'IsCheckBoxEnabled turns any of these (and the numeric/select fields) into an On/Off gated control that keeps an original value — off in these demos.',
  ],
  snippet:
    "<InputWithClear\n  type={InputTypesEnum.Bool}\n  fieldName='IsActive'\n  labelText='Is active'\n  value={value}\n  onChange={(fieldName, v) => setValue(v)}\n/>",
  render: InputsToggleDemoComponent,
};
